export function getEstados(){
    return [
        {
            id: 12,
            text: "AC",
            nome: "Acre"
        }, {
            id: 27,
            text: "AL",
            nome: "Alagoas"
        }, {
            id: 13,
            text: "AM",
            nome: "Amazonas"
        }, {
            id: 16,
            text: "AP",
            nome: "Amapá"
        }, {
            id: 29,
            text: "BA",
            nome: "Bahia"
        }, {
            id: 23,
            text: "CE",
            nome: "Ceará"
        }, {
            id: 53,
            text: "DF",
            nome: "Distrito Federal"
        }, {
            id: 32,
            text: "ES",
            nome: "Espírito Santo"
        }, {
            id: 52,
            text: "GO",
            nome: "Goiás"
        }, {
            id: 21,
            text: "MA",
            nome: "Maranhão"
        }, {
            id: 31,
            text: "MG",
            nome: "Minas Gerais"
        }, {
            id: 50,
            text: "MS",
            nome: "Mato Grosso do Sul"
        }, {
            id: 51,
            text: "MT",
            nome: "Mato Grosso"
        }, {
            id: 15,
            text: "PA",
            nome: "Pará"
        }, {
            id: 25,
            text: "PB",
            nome: "Paraíba"
        }, {
            id: 26,
            text: "PE",
            nome: "Pernambuco"
        }, {
            id: 22,
            text: "PI",
            nome: "Piauí"
        }, {
            id: 41,
            text: "PR",
            nome: "Paraná"
        }, {
            id: 33,
            text: "RJ",
            nome: "Rio de Janeiro"
        }, {
            id: 24,
            text: "RN",
            nome: "Rio Grande do Norte"
        },{
            id: 11,
            text: "RO",
            nome: "Rondônia"
        }, {
            id: 14,
            text: "RR",
            nome: "Roraima"
        }, {
            id: 43,
            text: "RS",
            nome: "Rio Grande do Sul"
        }, {
            id: 42,
            text: "SC",
            nome: "Santa Catarina"
        }, {
            id: 28,
            text: "SE",
            nome: "Sergipe"
        }, {
            id: 35,
            text: "SP",
            nome: "São Paulo"
        }, {
            id: 17,
            text: "TO",
            nome: "Tocantins"
        }
    ];
}

export function getEstadoById( id ){

    const listEstados = getEstados();

    var _estado = false;

    listEstados.forEach( ( estado ) => {
        if( parseInt( estado.id ) === parseInt( id ) ){ 
            _estado = estado.text;
        }
    });

    return _estado;

}

export function getEstadoByUF( UF ){
    let _estado = false;
    getEstados().map( estado => {
        if( estado.text === UF ) _estado = estado;
        return true;
    });
    return _estado;
}
